import { baseUrl } from "../config/env";
import type { Offer } from "../config/offers";
import { accentRailMarkup } from "./layout";

function isExternalUrl(url: string): boolean {
  return /^https?:\/\//.test(url);
}

export function renderIntakeHandoffPage(offer: Offer): string {
  const assetBase = baseUrl();
  const hasIntakeUrl = isExternalUrl(offer.intakeUrl);
  const intakeHref = hasIntakeUrl ? offer.intakeUrl : "/";

  return `
    <main class="handoff-page" data-screen-label="Post Payment Intake Handoff">
      <nav class="top-nav handoff-nav" aria-label="Primary">
        <a class="brand" href="/" aria-label="Foxmark home">
          <span class="brand-mark">
            <img src="${assetBase}assets/foxmark-logomark.png" alt="" width="40" height="47" />
            ${accentRailMarkup("brand-rail")}
          </span>
          <span>Foxmark</span>
        </a>
      </nav>

      <section class="handoff-hero">
        <div class="handoff-grid">
          <div class="handoff-copy">
            ${accentRailMarkup()}
            <p class="eyebrow">Payment received</p>
            <h1>Finish your ${offer.name} intake</h1>
            <p class="hero-subhead">
              Your subscription is set. The last step is a short intake form so Foxmark has the details needed to prepare your first monthly pack.
            </p>
            <div class="actions">
              <a
                class="button button-primary"
                href="${intakeHref}"
                data-intake-redirect
                data-auto-redirect="${hasIntakeUrl ? "true" : "false"}"
                data-delay-ms="5500"
              >Continue to intake form</a>
              <a class="button button-outline" href="/">Back to Foxmark</a>
            </div>
            <p class="proof-line">
              ${hasIntakeUrl ? "You will be sent to the intake form automatically." : "The intake form URL is not configured yet."}
            </p>
          </div>

          <aside class="handoff-panel" aria-label="What happens next">
            <p class="block-label">Next steps</p>
            <ol>
              <li><span>01</span><p>Complete the intake form with your business details.</p></li>
              <li><span>02</span><p>Foxmark reviews your public customer-facing signals.</p></li>
              <li><span>03</span><p>Your first monthly pack lands in your inbox.</p></li>
            </ol>
          </aside>
        </div>
      </section>
    </main>
  `;
}
